// extracted by mini-css-extract-plugin
export default {"questionText":"G_b9","info":"G_cb","question":"G_cc"};